import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsPageView() {
  const location = useLocation();

  useEffect(() => {
    const ga4Id = process.env.REACT_APP_GA4_ID || "";
    if (!ga4Id.startsWith("G-") || typeof window.gtag !== "function") return;
    window.gtag("config", ga4Id, {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
}